import { render, staticRenderFns } from "./accept-all-notifications-report-dialog.vue?vue&type=template&id=0007a6b6&scoped=true"
import script from "./accept-all-notifications-report-dialog.vue?vue&type=script&lang=js"
export * from "./accept-all-notifications-report-dialog.vue?vue&type=script&lang=js"
import style0 from "./accept-all-notifications-report-dialog.vue?vue&type=style&index=0&id=0007a6b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0007a6b6",
  null
  
)

export default component.exports